/* eslint-env node */

'use strict';

const baseConfig = require('./base');

let config = {
  parse: {
    appId: 'NGVEpNuOx2oLHIHmybrGXfyEebFkTwRR4tK6Ztyl',
    key: '0RKXe9y8bNHRRnLOJhrEnaBvuzrYXJKtpUg5Ir0E',
    serverURL: '/parse'
  },
  facebook: {
    appId: '560771857337475'
  },
  stripe: {
    pk: 'pk_live_QprqVhLaTDr2jCkhLG4XxEwg'
  },
  branch: {
    key: 'key_live_icfHx2MTuQRz6knqnYyL6kjevEomXTNh'
  },
  promoCodes: {
    signup: {
      fiveOff: 'DRINK5'
    }
  },
  orderTracking: {
    url: 'order.saucey-api.com'
  }
};

module.exports = Object.freeze(Object.assign({}, baseConfig, config));
